import type { FC, PropsWithChildren } from "react";
import React, { useMemo } from "react";

import { getChildrenRecord } from "../../../../../utils/react";
import { Divider } from "../../../../Divider";
import { BUTTON_CELL_SCHEVRON_OPTION_DISPLAY_NAME } from "../../utils/core";
import { createDisplayNameForButtonCellSchevronElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellSchevronElement } from "../../utils/getTestId";

import type { PropsWithTsId } from "../../../../../types/react";

import classes from "./ButtonCellSchevronOptionBottomAddon.styl";

const BOTTOM_ADDON_TEST_ID =
    createTestIdForButtonCellSchevronElement("bottom-addon");

type ButtonCellBottomAddonProps = Partial<PropsWithTsId> &
    PropsWithChildren & { prefix?: string };

export const ButtonCellSchevronOptionBottomAddon: FC<
    ButtonCellBottomAddonProps
> = ({
    "data-tsid": tsid,
    prefix = BUTTON_CELL_SCHEVRON_OPTION_DISPLAY_NAME,
    children,
}) => {
    const dataTestId = tsid || BOTTOM_ADDON_TEST_ID;

    const { FirstInlineButton, SecondInlineButton } = useMemo(
        () =>
            getChildrenRecord(children, prefix, {
                FirstInlineButton: {
                    required: true,
                },
                SecondInlineButton: {
                    required: true,
                },
                Unknown: {
                    skipElement: true,
                },
            }),
        [children, prefix],
    );

    return (
        <div className={classes["bottom-addon"]} data-tsid={dataTestId}>
            {FirstInlineButton}

            <Divider
                view="primary"
                direction="vertical"
                customVarsStyles={classes["divider-paddings"]}
            />

            {SecondInlineButton}
        </div>
    );
};

ButtonCellSchevronOptionBottomAddon.displayName =
    createDisplayNameForButtonCellSchevronElement("BottomAddon");

export default ButtonCellSchevronOptionBottomAddon;
